@import "../../globalStyles/commons";

:host {
  display: block;
  height: 100%;
  min-height: 20em;
  --goat-table-border-color: #{v(--border-subtle)};
  --goat-table-border: 1px solid var(--goat-table-border-color);
  --goat-col-content-padding: #{v(--spacing-04)} #{v(--spacing-05)};
}

.table {
  height: 100%;

  @include font-style(body-compact-01);
  display: flex;
  flex-direction: column;
  background: var(--layer);

  .table-scroll-container {
    position: relative;
    overflow: auto;
    height: 100%;
  }

  .empty-table {
    height: 80%;
    display: flex;
    align-items: center;
    justify-content: center;

    .empty-state {
      width: 10rem;
    }
  }

  .pagination {
    background: var(--layer);
    --input-background-color: var(--layer);
    display: flex;
    border-top: 1px solid var(--goat-table-border-color);

    .form-control {
      margin: 0;
    }

    .select {
      margin: 0;
      --input-border-radius: none;
      --input-border: none;
      --input-border-inline-start: 1px solid var(--goat-table-border-color);
      --input-border-inline-end: 1px solid var(--goat-table-border-color);
    }

    .page-sizes-select {
      margin-inline-start: v(--spacing-03);
    }

    .pagination-item-count {
      margin-inline-start: v(--spacing-04);
      flex: 1;
      display: flex;
      align-items: center;
    }

    .arrows {
      --border-radius: 0;
      --goat-button-height: calc(2.5rem - 2px);
    }
  }

  &.horizontal-scrolled {
    .fixed-columns:after {
      box-shadow: 10px 0 20px -20px #{v(--border-color)} inset;
      content: " ";
      height: 100%;
      position: absolute;
      top: 0;
      right: -20px;
      width: 20px;
    }
  }
}


.row {
  display: flex;
  box-sizing: border-box;


  .columns-container {
    display: flex;
  }

  .col {
    margin: 0;
    color: var(--text-primary);

    .col-content {
      display: flex;
      align-items: center;
      height: 100%;

      .col-text {
        padding: var(--goat-col-content-padding);
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .col-template {
        width: 100%;
      }

      .col-action {
        --goat-button-border-radius: none;

        &.has-focus {
          z-index: 12;
        }
      }

      .checkbox {
        padding: 0 var(--spacing-03);
      }
    }

    &.center .col-content {
      justify-content: center;
    }

    &:last-child {
      flex: 1;
    }
  }

  .fixed-columns {
    position: sticky;
    left: 0;
    z-index: 1;
  }

  .scrollable-columns {
    flex: 1;
    /*z-index: 0;*/
  }

}

.header {
  z-index: v(--z-index-table-header);
  @include font-style(heading-compact-01);
  position: sticky;
  top: 0;


  .left-panel {
    position: sticky;
    top: 0;
    left: 0;
  }

  .col {
    background: var(--layer-accent);

    &.sort {
      background: var(--layer-selected-hover);
    }
  }
}

.body {

  .row {

    .col {
      cursor: pointer;
      background: var(--layer);
      border-bottom: 1px solid var(--layer-accent);

      &.col-checkbox .col-content {
        border: 0;
      }

      .col-content {
        border: 2px solid transparent;
        border-bottom: 1px solid transparent;

        .col-text {
          text-wrap: wrap;
        }
      }

      &:focus {
        outline: none;
        border-bottom-color: v(--color-primary);
        z-index: 1;

        .col-content {
          border-color: v(--color-primary);


        }
      }
    }

    &:hover {
      .col {
        background-color: var(--layer-hover);
      }
    }
  }

  .left-panel {
    position: sticky;
    left: 0;
  }

}

:host-context(.no-wrap-column) {
  .row .col .col-content .col-text {
    text-wrap: nowrap;
  }
}


.empty-data {
  text-align: center;
  position: absolute;
  margin: auto;
  top: 46px;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 3px;
  height: max-content;
  color: v(--color-neutral-600);
}
